import { useApplicationStore } from '../../../model/store'

// Какой info-блок можно заполнить из заявления при выбранном customer_kind:
// если заказчик — сам поступающий, то можно дозаполнить customer-блок;
// если заказчик — иной человек, то можно дозаполнить applicant-блок (поступающего).
const FILLABLE_BY_CUSTOMER_KIND = {
  applicant: 'customer',
  other_person: 'applicant',
}

export function useFillFromApplication(form, infos) {
  const store = useApplicationStore()

  const canFillFromApplication = (kind) =>
    FILLABLE_BY_CUSTOMER_KIND[form.value.customer_kind] === kind

  const fillFromApplication = (kind) => {
    const app = store.application
    Object.assign(infos.value[kind], {
      surname: app.surname,
      name: app.name,
      patronymic: app.patronymic,
      birthdate: app.birthdate,
      phone: app.phone,
      email: app.email,
      birth_place_address: app.birth_place?.address_free_form,
      registration_address: app.registration?.address_free_form,
      identity_document_type: app.identity?.document_type,
      identity_series: app.identity?.series,
      identity_number: app.identity?.number,
      identity_date: app.identity?.date,
      identity_contragent: app.identity?.contragent,
      identity_contragent_code: app.identity?.contragent_code,
    })
  }

  return { canFillFromApplication, fillFromApplication }
}
